import type { NativeStackScreenProps } from "@react-navigation/native-stack";
import { observer } from "mobx-react-lite";
import React from "react";
import { useStores } from "../../core/stores";
import BusinessPlanScreen from "./BusinessPlanScreen";
import { BusinessPlanSectionModuleUI } from "./tabs/BusinessPlanSectionModuleUI";

type Props = NativeStackScreenProps<
  ReactNavigation.RootParamList,
  "BusinessSectionModule"
>;

export const BusinessPlanSectionModuleScreen = observer((props: Props) => {
  const { businessPlansStore } = useStores();

  const businessPlan = businessPlansStore.byId.get(
    props.route.params.businessUid,
  );

  const section = businessPlan?.getSectionByInfoItem(
    props.route.params.itemUid,
  );

  return (
    <BusinessPlanScreen {...props}>
      {section && (
        <BusinessPlanSectionModuleUI
          section={section}
          businessPlanUid={props.route.params.businessUid}
          businessModuleUid={props.route.params.itemUid}
        />
      )}
    </BusinessPlanScreen>
  );
});

export default BusinessPlanSectionModuleScreen;
